import { gql } from 'apollo-angular';

export const GET_PRODUCT_RECOMMENDATIONS = gql`
  query GetProductRecommendations($productId: ID!) {
    productRecommendations(productId: $productId) {
      id
      title
      descriptionHtml
      handle
      totalInventory
      vendor
      tags
      priceRange {
        minVariantPrice {
          amount
        }
      }
      featuredImage {
        url(transform: { maxHeight: 2000, maxWidth: 2000 })
        altText
        width
        height
        id
      }
      seo {
        title
        description
      }
      ... on Product {
        variants(first: 25) {
          edges {
            node {
              id
              availableForSale
              quantityAvailable
              sku
              title
              price {
                amount
              }
              sellingPlanAllocations(first:3) {
                edges {
                  node {
                    sellingPlan {
                      id
                      name
                      options {
                        name
                        value
                      }
                    }
                    priceAdjustments {
                      price {
                        amount
                        currencyCode
                      }
                      compareAtPrice {
                        amount
                        currencyCode
                      }
                      perDeliveryPrice {
                        amount
                        currencyCode
                      }
                      unitPrice {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
              weight
              weightUnit
              image {
                url(transform: { maxHeight: 2000, maxWidth: 2000 })
                altText
                width
                height
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_BY_HANDLE = gql`
  query GetProductByHandle($handle: String!) {
    product(handle: $handle) {
      id
      title
      descriptionHtml
      handle
      totalInventory
      vendor
      tags
      requiresSellingPlan
      sellingPlanGroups(first:3) {
        edges {
          node {
            name
            options {
              name
              values
            }
            sellingPlans(first: 5) {
              edges {
                node {
                  id
                  name
                  description
                  recurringDeliveries
                  priceAdjustments {
                    orderCount
                    adjustmentValue {
                      __typename
                      ... on SellingPlanPercentagePriceAdjustment {
                        adjustmentPercentage
                      }
                      ... on SellingPlanFixedAmountPriceAdjustment {
                        adjustmentAmount {
                          amount
                          currencyCode
                        }
                      }
                      ... on SellingPlanFixedPriceAdjustment {
                        price {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      priceRange {
        minVariantPrice {
          amount
        }
      }
      featuredImage {
        url(transform: { maxHeight: 2000, maxWidth: 2000 })
        altText
        width
        height
        id
      }
      seo {
        title
        description
      }
      ... on Product {
        variants(first: 25) {
          edges {
            node {
              id
              availableForSale
              quantityAvailable
              sku
              title
              price {
                amount
              }
              sellingPlanAllocations(first:3) {
                edges {
                  node {
                    sellingPlan {
                      id
                      name
                      options {
                        name
                        value
                      }
                    }
                    priceAdjustments {
                      price {
                        amount
                        currencyCode
                      }
                      compareAtPrice {
                        amount
                        currencyCode
                      }
                      perDeliveryPrice {
                        amount
                        currencyCode
                      }
                      unitPrice {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
              weight
              weightUnit
              image {
                url(transform: { maxHeight: 2000, maxWidth: 2000 })
                altText
                width
                height
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_BY_ID = gql`
  query GetProductById($id: ID!) {
    product(id: $id) {
      id
      title
      descriptionHtml
      handle
      totalInventory
      vendor
      tags
      requiresSellingPlan
      sellingPlanGroups(first:3) {
        edges {
          node {
            name
            options {
              name
              values
            }
            sellingPlans(first: 5) {
              edges {
                node {
                  id
                  name
                  description
                  recurringDeliveries
                  priceAdjustments {
                    orderCount
                    adjustmentValue {
                      __typename
                      ... on SellingPlanPercentagePriceAdjustment {
                        adjustmentPercentage
                      }
                      ... on SellingPlanFixedAmountPriceAdjustment {
                        adjustmentAmount {
                          amount
                          currencyCode
                        }
                      }
                      ... on SellingPlanFixedPriceAdjustment {
                        price {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      seo {
        title
        description
      }
      priceRange {
        minVariantPrice {
          amount
        }
      }
      featuredImage {
        url(transform: { maxHeight: 2000, maxWidth: 2000 })
        altText
        width
        height
        id
      }
      ... on Product {
        variants(first: 25) {
          edges {
            node {
              id
              availableForSale
              quantityAvailable
              sku
              title
              price {
                amount
              }
              sellingPlanAllocations(first:3) {
                edges {
                  node {
                    sellingPlan {
                      id
                      name
                      options {
                        name
                        value
                      }
                    }
                    priceAdjustments {
                      price {
                        amount
                        currencyCode
                      }
                      compareAtPrice {
                        amount
                        currencyCode
                      }
                      perDeliveryPrice {
                        amount
                        currencyCode
                      }
                      unitPrice {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
              weight
              weightUnit
              image {
                url(transform: { maxHeight: 2000, maxWidth: 2000 })
                altText
                width
                height
                id
              }
            }
          }
        }
      }
    }
  }
`;
